import React, { Component } from "react";
import ug from "../assets/ug.svg";
// import circletick from "../assets/circletick.svg";
import { NumericFormat } from "react-number-format";
import { Modal } from "react-bootstrap";
import CustomButton from "../components/CustomButton";
import Cancel from "../assets/cancel.svg";
import Tick from "../assets/tick.svg";
import { Icon } from "@iconify/react";
import circleTick from "@iconify/icons-charm/circle-tick";

export default class UserGroupItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ModalShow: false,
      priceValue: "",
      priceErrorText: "",
      ModalShow1: false,
      percentValue: "",
      percentErrorText: "",
    };

    // console.log("item:", this.props.item);
    // console.log("percent:", this.props.withPercent);
  }

  onClick() {
    // console.log(this.props.withPrice);
    // console.log(this.props.withPercent);
    if (this.props.withPrice && !this.props.selected) {
      this.setState({ priceValue: "", priceErrorText: "", ModalShow: true });
    } else if (this.props.withPercent && !this.props.selected) {
      this.setState({
        percentValue: "",
        percentErrorText: "",
        ModalShow1: true,
      });
    } else {
      this.props.onSelected(this.props.id, null);
    }
  }

  onSavePrice() {
    this.props.onSelected(this.props.id, Number(this.state.priceValue));
    this.setState({ ModalShow: false });
  }

  onSavePercent() {
    this.props.onSelected(this.props.id, Number(this.state.percentValue));
    this.setState({ ModalShow1: false });
  }

  hideModal() {
    this.setState({ ModalShow: false, ModalShow1: false });
  }

  render() {
    return (
      <div
        className="UGItem"
        style={{
          backgroundColor: this.props.sub ? "var(--gray5)" : "white",
          marginRight: this.props.sub ? "10px" : "0px",
          border: this.props.sub
            ? "1px solid var(--gray3)"
            : this.props.border
            ? this.props.border
            : "none",
          fontSize: this.props.sub ? "14px" : "16px",
          color: this.props.sub ? "var(--black2)" : "var(--black1)",
          lineHieght: this.props.sub ? "15px" : "25px",
          padding: this.props.sub ? "0px 5px" : "5px",
        }}
      >
        <div
          onClick={this.onClick.bind(this)}
          style={{
            width: "100%",
            padding: "5px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", flexDirection: "row" }}>
            {!this.props.notShowIcon && (
              <img
                src={ug}
                alt=""
                style={{
                  height: "25px",
                  objectFit: "contain",
                  marginLeft: "10px",
                }}
              />
            )}
            <div>{this.props.name}</div>
            {this.props.item && this.props.item.titleFa && (
              <div
                style={{
                  margin: "0px 10px",
                  fontSize: "12px",
                  color: "var(--brown1)",
                }}
              >
                ({this.props.item.titleFa})
              </div>
            )}
          </div>
          {this.props.selected && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {this.props.item &&
                (this.props.withPercent || this.props.withPrice) &&
                (this.props.item.taxPercent || this.props.item.packingPrice) &&
                this.props.sub && (
                  <div style={{ fontSize: "0.8em" }}>
                    {this.props.withPercent && this.props.item.taxPercent ? (
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginLeft: "3px" }}>%</div>
                        <NumericFormat
                          type="text"
                          value={this.props.item.taxPercent}
                          allowNegative={true}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </div>
                    ) : this.props.withPrice && this.props.item.packingPrice ? (
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginLeft: "3px" }}>
                          {this.props.rtlPriceTitle}
                        </div>
                        <NumericFormat
                          type="text"
                          value={this.props.item.packingPrice}
                          allowNegative={true}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </div>
                    ) : null}
                  </div>
                )}

              {this.props.item &&
                (this.props.withPercent || this.props.withPrice) &&
                ((this.props.item.taxPercent &&
                  this.props.item.taxPercent !== 0) ||
                  (this.props.item.packingPrice &&
                    this.props.item.packingPrice !== 0)) &&
                this.props.sub && (
                  <div
                    style={{
                      height: "20px",
                      minWidth: "1px",
                      backgroundColor: "var(--gray3)",
                      margin: "0px 10px",
                    }}
                  />
                )}
              <Icon
                icon={circleTick}
                color={this.props.sub ? "var(--black2)" : "var(--black1)"}
                width="18"
                height="18"
              />
            </div>
          )}
        </div>

        <Modal
          show={this.state.ModalShow}
          animation={true}
          size="sm"
          backdrop="static"
          backdropClassName="backdropClassName"
          onHide={this.hideModal.bind(this)}
          centered
        >
          <div className="settingContainer" style={{ padding: "5px" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              <div className="settingItemContainer">
                <div className="settingLabel">مبلغ بسته‌بندی</div>
                <NumericFormat
                  className={
                    this.state.priceErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter form-control"
                      : "form-control inputStyleForm textAlignCenter"
                  }
                  style={{ maxWidth: "120px", direction: "ltr" }}
                  placeholder={this.props.rtlPriceTitle}
                  type="text"
                  name="priceValue"
                  onValueChange={(values) => {
                    this.setState({
                      priceValue: values.value,
                    });
                  }}
                  value={this.state.priceValue}
                  allowNegative={true}
                  displayType={"input"}
                  thousandSeparator={true}
                />
              </div>
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: "500px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="ذخیره"
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.onSavePrice.bind(this)}
                />
              </div>
              <div style={{ minWidth: "10px" }} />
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={this.hideModal.bind(this)}
                />
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          show={this.state.ModalShow1}
          animation={true}
          size="sm"
          backdrop="static"
          backdropClassName="backdropClassName"
          onHide={this.hideModal.bind(this)}
          centered
        >
          <div className="settingContainer" style={{ padding: "5px" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              <div className="settingItemContainer">
                <div className="settingLabel">درصد مالیات</div>
                <NumericFormat
                  className={
                    this.state.percentErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter form-control"
                      : "form-control inputStyleForm textAlignCenter"
                  }
                  style={{ maxWidth: "120px", direction: "ltr" }}
                  placeholder="درصد %"
                  type="text"
                  name="percentValue"
                  onValueChange={(values) => {
                    this.setState({
                      percentValue: values.value,
                    });
                  }}
                  value={this.state.percentValue}
                  allowNegative={true}
                  displayType={"input"}
                  thousandSeparator={true}
                />
              </div>
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: "500px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="ذخیره"
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.onSavePercent.bind(this)}
                />
              </div>
              <div style={{ minWidth: "10px" }} />
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={this.hideModal.bind(this)}
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
